import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faThumbsDown, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { NexusComponent } from 'app/core/components/nexus/nexus.component';
import {  SurveyQuestionDialogModel, SurveyQuestionResponseModel } from 'app/core/models/survey-question-response.model';
import { SurveyResponseService } from 'app/core/services/survey-response.service';

@Component({
    selector: 'app-survey-question-dialog',
    templateUrl: './survey-question-dialog.component.html',
    styleUrls: ['./survey-question-dialog.component.scss'],
    standalone: false
})
export class SurveyQuestionDialogComponent extends NexusComponent implements OnInit {

  public survey_question_dialog: SurveyQuestionDialogModel;
  public feedback_text: string;
  public faThumbsDown = faThumbsDown;
  public faThumbsUp = faThumbsUp;
  public show_feedback = true;
  public like_dislike_feedback = true;
  public survey_question_response_model =  new SurveyQuestionResponseModel();
  constructor(
      public dialogRef: MatDialogRef<SurveyQuestionDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: SurveyQuestionDialogModel, private survey_response_service: SurveyResponseService, ) {
        super();
    this.survey_question_dialog = data;

  }

  ngOnInit(): void {
    this.survey_question_response_model.survey_questionId = this.survey_question_dialog.survey_question_id;
    this.survey_question_response_model.survey_meta = this.survey_question_dialog.survey_meta;
    this.set_like_dislike_feedback();
  }


  set_show_feedback(){
    this.show_feedback = true;
    this.like_dislike_feedback =false;
  }
  feedback_close_dialog(value: boolean){
    this.show_feedback = false;
    this.like_dislike_feedback =false;
    this.dialogRef.close(value);
  }
  set_like_dislike_feedback(){
    this.show_feedback = false;
    this.like_dislike_feedback =true;
  }
  thumb_click(value: boolean){
    this.survey_question_response_model.thumbs_up_down = value;
    this.update_survey_question_response(this.survey_question_response_model,()=> {this.set_show_feedback();});
  }
  submit_click(){
    this.survey_question_response_model.feedback_text = this.feedback_text;
    this.update_survey_question_response(this.survey_question_response_model,()=> {this.feedback_close_dialog(true);});
  }
  dismiss_click(){
    this.survey_question_response_model.dismissed = true;
    this.update_survey_question_response(this.survey_question_response_model,()=> {this.feedback_close_dialog(this.show_feedback);});
  }

  update_survey_question_response(payload: SurveyQuestionResponseModel,call_back: Function) {
    this.StartSpinner();
    this.survey_response_service.PutSurveyResponse(payload).subscribe(
        data => {
            payload.id = data.id;
            this.StopSpinner();
            if(call_back!= null){
              call_back();
            }

        },
        err => {
            this.StopSpinner();
            if(call_back!= null){
              call_back();
            }
        });
}
}
